import React from "react";

import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	startDate: {
		k: "subscription.startDate",
		v: "Start Date",
	},

	startDateHelp: {
		k: "subscription.startDate.helpText",
		v: "First day of subscription"
	},

	endDate: {
		k: "subscription.endDate",
		v: "End Date"
	},

	endDateHelp: {
		k: "subscription.endDate.helpText",
		v: "Last day of access to this course"
	},

	timeSpent: {
		k: "subscription.timeSpent",
		v: "Time Spent"
	},

	timeSpentHelp: {
		k: "subscription.timeSpent.helpText",
		v: "Duration spent in course"
	},

	lastVisited: {
		k: "subscription.lastVisited",
		v: "Last Launched"
	},

	lastVisitedHelp: {
		k: "subscription.lastVisited.helpText",
		v: "Last day course was launched"
	},

	completedOn: {
		k: "subscription.completedOn",
		v: "Completed On ${date}",
		argNames: ["date"]
	},

	certificates: {
		k: "subscription.certificates",
		v: "${count} Certificates Earned",
		argNames: ["count"]
	},

	daysToAccess: {
		k: "subscription.daysToAccess",
		v: "Days To Access"
	},

	main: {
		k: "subscription.main",
		v: "Main"
	},

	score: {
		k: "subscription.score",
		v: "Score"
	},

	credits: {
		k: "subscription.credits",
		v: "Credits"
	},

	totalCredits: {
		k: "subscription.totalCredits",
		v: "TotalCredits"
	},

	certificate: {
		k: "subscription.certificates.download",
		v: "Certificates"
	}

});



// WEBPACK FOOTER //
// ./src/panels/subscriptions/component/labels.tsx